import { createAsyncThunk } from "@reduxjs/toolkit";
import AreaApi from "api/AreaApi";

export const fetchArea = createAsyncThunk(
  "fetchArea",
  ({ companyId, shopId }: { companyId: number; shopId: number }) =>
    AreaApi.fetchArea(companyId, shopId)
);
